/**
 * Budget Filter Pills
 *
 * Three-option pill selector for filtering budgets: All, Household, Personal.
 * Follows the same Tabs pattern as PerspectivePills on the accounts page.
 */

import { Icon, IconKey } from '@/shared/components/icon';
import { Tabs, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';

export type BudgetPerspective = 'all' | 'household' | 'personal';

const OPTIONS: { value: BudgetPerspective; label: string; icon?: IconKey }[] = [
  { value: 'all', label: 'All' },
  { value: 'household', label: 'Household', icon: IconKey.Users },
  { value: 'personal', label: 'Personal', icon: IconKey.User },
];

interface BudgetFilterPillsProps {
  value: BudgetPerspective;
  onChange: (value: BudgetPerspective) => void;
}

export function BudgetFilterPills({ value, onChange }: BudgetFilterPillsProps) {
  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as BudgetPerspective)}>
      <TabsList className="gap-1 bg-primary/10">
        {OPTIONS.map((option) => (
          <TabsTrigger
            key={option.value}
            value={option.value}
            className="gap-2 text-xs hover:cursor-pointer hover:bg-primary/10"
          >
            {option.icon && <Icon icon={option.icon} size={14} />}
            <span>{option.label}</span>
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
